module.exports = __webpack_public_path__ + "img/flavor2.abcff97d.svg";